var baseDelay = require('../internal/baseDelay');

/**
 * Invokes `func` after `wait` milliseconds. Any additional arguments are
 * provided to `func` when it is invoked.
 *
 * @static
 * @memberOf _
 * @category Function
 * @param {Function} func The function to delay.
 * @param {number} wait The number of milliseconds to delay invocation.
 * @param {...*} [args] The arguments to invoke the function with.
 * @returns {number} Returns the timer id.
 * @example
 *
 * _.delay(function(text) {
 *   console.log(text);
 * }, 1000, 'later');
 * // => logs 'later' after one second
 */
function delay(func, wait) {
  return baseDelay(func, wait, arguments, 2);
}

module.exports = delay;



/*****************
 ** WEBPACK FOOTER
 ** ./~/substance/~/lodash/function/delay.js
 ** module id = 171
 ** module chunks = 0
 **/